import React, { useState } from "react";
import { formatDateWithTime } from "../../../shared/utility";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function BarcodeHistoryTable(props) {
  const { historyData } = props;

  const bodyFormatCreatedDate = (item) => {
    return <p>{formatDateWithTime(item.created_date)}</p>;
  };

  return (
    <div className="flow-root">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 space-y-2">
          <div className="overflow-hidden card-custom bg-white">
            <DataTable
              value={historyData}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
              cellClassName="p-2 border-1-bottom-gray text-sm"
            >
              <Column header="Action" field="action" style={{ width: "15%" }} />
              <Column
                header="Date"
                body={bodyFormatCreatedDate}
                style={{ width: "15%" }}
              />
              <Column
                header="Operator"
                field="operator"
                style={{ width: "10%" }}
              />
              <Column header="Amount" field="amount" style={{ width: "10%" }} />
              <Column
                header="From Warehouse"
                field="from_warehouse_name"
                style={{ width: "15%" }}
              />
              <Column
                header="From Location"
                field="from_warehouse_location"
                style={{ width: "15%" }}
              />
              <Column
                header="To Warehouse"
                field="to_warehouse_name"
                style={{ width: "10%" }}
              />
              <Column
                header="To Location"
                field="to_warehouse_location"
                style={{ width: "10%" }}
              />
              <Column header="Reason" field="reason" style={{ width: "15%" }} />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
}
